export class Modal {
    constructor (target) {
      this.section = target;
    }

    async init () {
      if (!this.section || CMS.editMode) {
        return;
      }

      const { Foundation } = await import('foundation-sites/js/foundation.core');
      const { Reveal } = await import('foundation-sites/js/foundation.reveal');

      Foundation.plugin(Reveal, 'Reveal');

      const modalSelector = $(this.section);
      const openDelay = modalSelector.data('show-delay');
      const openDelayValue = isNaN(openDelay) ? 0 : openDelay;
      const closeModalSelector = modalSelector.find('.close-button');
      const modal = new Foundation.Reveal(modalSelector);

      setTimeout(() => {
        modal.open();
      }, openDelayValue);

      closeModalSelector.on('click', () => {
        modal.close();
      });

      this.loading(false);
    }

    loading(isLoading = true) {
      this.section.classList.toggle('loading', isLoading);
    }
}
